import React from "react";
import Icons from "components/icons";
import { Localize } from "components/service";
import { getStaffAuditAction } from "../helpers/staff-audit-log-presentation-helper";


const actionIcons = {
    check_in: Icons.StaffCheckIn,
    check_out: Icons.StaffCheckOut,
};

const StaffAuditActionField = ({ action }) => {
    const safeAction = getStaffAuditAction(action);
    const ActionIcon = actionIcons[ safeAction ];

    return (
        <span className={ `staff-audit-action staff-audit-action--${ safeAction }` }>
            { ActionIcon &&
                <span className="d-flex align-items-center justify-content-center staff-audit-action__icon" aria-hidden="true">
                    <ActionIcon />
                </span>
            }
            <Localize>{ `STAFF_MANAGEMENT.AuditAction_${ safeAction }` }</Localize>
        </span>
    );
};

export default StaffAuditActionField;
